// extracted by mini-css-extract-plugin
export default {"overlay":"qx-z","bodyOpen":"rx-z","content":"sx-z","header":"tx-z","close":"ux-z","closeNoHeading":"vx-z"};